<script lang="ts">
  import BasicLink from './BasicLink.svelte'
  import DropdownMenu from './DropdownMenu.svelte'

  const links = [
    {
      title: '(IT, CH) Smart Border: La Frontiera Intelligente',
      subtitle:
        'Armonizzazione E Sviluppo Dei Collegamenti Sostenibili Fra L’Alto Verbano E Il Ceresio Occidentale',
      link: 'https://progetti.interreg-italiasvizzera.eu/it/b/78/lafrontieraintelligentearmonizzazioneesviluppodeicollegamentisostenibi',
    },
    {
      title: '(CH, IT) TI CICLO VIA',
      subtitle:
        'Sviluppo Di Un Sistema Mobilità Ciclabile Transfrontaliera Nei Territori Delle Valli Dell’Olona, Del Lanza E Del Mendrisiotto',
      link: 'https://progetti.interreg-italiasvizzera.eu/it/b/78/ticicloviasviluppodiunsistemamobilitciclabiletransfrontalieraneiterrit',
    },
    {
      title: '(CH, IT) UN DUE TRESA',
      subtitle: 'Un progetto per la mobilità sostenibile sulle rive della Tresa',
      link: 'https://progetti.interreg-italiasvizzera.eu/it/b/78/unprogettoperlamobilitasostenibilesullerivedellatresa',
    },
    {
      title: '(IT, CH) SMISTO',
      subtitle: 'Sviluppo Della Mobilità Integrata E Sostenibile Tra Ticino E Lombardia',
      link: 'https://progetti.interreg-italiasvizzera.eu/it/b/78/sviluppodellamobilitaintegrataesostenibiletraticinoelombardia',
    },
  ]
</script>

<DropdownMenu selected="Buone pratiche" />

<div class="best-practices-wrapper">
  <p class="intro" />

  <div class="mezzi-alternativi">
    <div class="links">
      {#each links as { title, subtitle, link }}
        <BasicLink {link} {title} {subtitle} />
      {/each}
    </div>
  </div>
</div>

<style>
  .best-practices-wrapper {
    margin-top: 55px;
    padding: 1rem 2rem;
  }

  .intro {
    color: #7b7b7b;
  }
</style>
